import React, { useEffect, useRef, useState } from "react";
import "../../Styles/CommonStyles.scss";
import { IPersonalInfo } from "../../store/memberInterfaceStruct";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from "dayjs";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import type {} from "@mui/x-date-pickers/themeAugmentation";
import {
  updateMember_Tags,
  updateMemberPersonalInfo,
} from "../../store/memberApiSlice";
import { useAppSelector } from "../../store/hooks";

interface IConfiguration {
  [key: string]: any;
}

interface Iprops {
  configurationList: IConfiguration;
}

const CreateMemberPersonal: React.FC<Iprops> = (props) => {
  const personalInfo = useSelector(
    (state: RootState) => state.memberApiSlice.Personal
  );

  const form = useForm<IPersonalInfo>();
  const { register, control, handleSubmit, formState, setValue, clearErrors } =
    form;
  const { errors, touchedFields, dirtyFields } = formState;

  const dispatch = useDispatch();

  function capitalizeFirstLetter(str: string) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  const [dateOfBirth, setDateOfBirth] = React.useState<string>("");
  const [admitDate, setAdmitDate] = React.useState<string>("");
  const [MediatorCertificationEndsOn, setMediatorCertificationEndsOn] =
    React.useState<string>("");
  const [isMediator, setIsMediator] = useState<boolean>(
    personalInfo.IsMediator
  );
  const [isArbitrator, setIsArbitrator] = useState<boolean>(
    personalInfo.Arbitrator
  );

  useEffect(() => {}, []);

  useEffect(() => {
    // Fetch the date from the Redux store and set it in the form
    setValue("MemberCodeId", personalInfo.MemberCodeId, {
      shouldDirty: true,
    });

    setDateOfBirth(dayjs(personalInfo.DateOfBirth).format("DD-MM-YYYY"));

    // if (dayjs(personalInfo.DateOfBirth).isValid()) {
    //   setValue("DateOfBirth", dayjs(personalInfo.DateOfBirth!), {
    //     shouldDirty: true,
    //   });
    // }

    setAdmitDate(dayjs(personalInfo.AdmitDate).format("MM-DD-YYYY"));

    // dayjs(personalInfo.AdmitDate).isValid() &&
    //   setValue("AdmitDate", dayjs(personalInfo.AdmitDate), {
    //     shouldDirty: true,
    //   });

    setMediatorCertificationEndsOn(
      dayjs(personalInfo.MediatorCertificationEndsOn).format("MM-DD-YYYY")
    );

    // dayjs(personalInfo.MediatorCertificationEndsOn).isValid &&
    //   setValue(
    //     "MediatorCertificationEndsOn",
    //     dayjs(personalInfo.MediatorCertificationEndsOn!),
    //     {
    //       shouldDirty: true,
    //     }
    //   );

    console.log("useEffect-createMemberBody changed");
  }, [personalInfo, setValue]);

  const updateInput = (
    event: React.ChangeEvent<HTMLInputElement>,
    flag?: string
  ): void => {
    switch (event.target.name) {
      case "BarId":
        // setbarId(event.target.value);
        // dispatch(updateMember_BarId(event.target.value));
        dispatch(
          updateMemberPersonalInfo({
            key: event.target.name,
            value: event.target.value,
          })
        );
        setValue("BarId", event.target.value, {
          shouldDirty: true,
        });
        clearErrors("BarId");
        break;
      case "FirstName":
        const firstName = capitalizeFirstLetter(event.target.value);
        // dispatch(updateMember_FirstName(firstName));
        dispatch(
          updateMemberPersonalInfo({
            key: event.target.name,
            value: firstName,
          })
        );
        setValue("FirstName", firstName, {
          shouldDirty: true,
        });
        clearErrors("FirstName");
        break;
      case "LastName":
        const lastName = capitalizeFirstLetter(event.target.value);
        // dispatch(updateMember_LastName(lastName));
        dispatch(
          updateMemberPersonalInfo({
            key: event.target.name,
            value: lastName,
          })
        );
        setValue("LastName", lastName, {
          shouldDirty: true,
        });
        clearErrors("LastName");
        break;

      case "IsMediatorOrArbitrator":
        if (flag === "isMediator") {
          setIsMediator(true);
          setIsArbitrator(false);
        } else {
          setIsMediator(false);
          setIsArbitrator(true);
        }
        // dispatch(updateMember_IsMediator(event.target.checked));
        if (flag === "isMediator") {
          dispatch(
            updateMemberPersonalInfo({
              key: "IsMediator",
              value: true,
            })
          );
          dispatch(
            updateMemberPersonalInfo({
              key: "IsArbitrator",
              value: false,
            })
          );
        } else {
          dispatch(
            updateMemberPersonalInfo({
              key: "IsMediator",
              value: false,
            })
          );
          dispatch(
            updateMemberPersonalInfo({
              key: "IsArbitrator",
              value: true,
            })
          );
        }
        break;

      default:
        break;
    }
  };

  const updateSelectBox = (
    event: React.ChangeEvent<HTMLSelectElement>
  ): void => {
    switch (event.target.name) {
      case "MemberCodeId":
        // dispatch(updateMember_MemberCodeId(Number(event.target.selectedIndex)));

        dispatch(
          updateMemberPersonalInfo({
            key: event.target.name,
            value: Number(event.target.value),
          })
        );

        setValue("MemberCodeId", Number(event.target.value), {
          shouldDirty: true,
        });

        // for few member code membership NoInvoice should be selected automatically
        // "Id": 21, "MemberCode": "DE", deseased
        //"Id": 22,"MemberCode": "SU", suspended
        // if (
        //   Number(event.target.value) === 21 ||
        //   Number(event.target.value) === 22
        // ) {
        //   setSelectedItems((selectedItems) => [...selectedItems!, 4]);
        // }
        // dispatch(updateMember_Tags(selectedItems as number[]));

        clearErrors("MemberCodeId");
        break;
      case "Title":
        dispatch(
          updateMemberPersonalInfo({
            key: event.target.name,
            value: event.target.value,
          })
        );
        break;
      case "Esquire":
        // dispatch(updateMember_Esquire(event.target.value));
        dispatch(
          updateMemberPersonalInfo({
            key: event.target.name,
            value: event.target.value,
          })
        );
        break;
      case "Gender":
        // dispatch(updateMember_Gender(event.target.value));
        dispatch(
          updateMemberPersonalInfo({
            key: event.target.name,
            value: event.target.value,
          })
        );
        break;
      default:
        break;
    }
  };
  const color1 = "#2d6289";
  const color2 = "#008800";
  const colorError = "#FF0000";
  const muiDatePickerColorTheme = (theme: any) =>
    createTheme({
      ...theme,
      palette: {
        primary: {
          main: color1,
        },
        secondary: {
          main: color1,
        },
        // error: {
        //   main: color1,
        // },
      },
      components: {
        MuiIconButton: {
          styleOverrides: {
            sizeMedium: {
              color1,
            },
          },
        },
        MuiOutlinedInput: {
          styleOverrides: {
            root: {
              borderRadius: 0,
            },
            notchedOutline: {
              borderWidth: 0,
              borderBottomStyle: "solid",
              borderBottomWidth: 1,
            },
            input: {
              height: "0.8rem",
              background: "var(--form-input-background-color)",
            },
          },
        },
        MuiDatePicker: {
          styleOverrides: {
            root: {
              margin: "normal",
            },
          },
        },
        MuiInputLabel: {
          styleOverrides: {
            root: {
              color: color1,
              zIndex: 1,
            },
          },
        },
        MuiFormLabel: {
          styleOverrides: {
            root: {
              fontWeight: 400,
              color: color1,
            },
          },
        },
        MuiInputBase: {
          styleOverrides: {
            root: {
              background: "var(--form-input-background-color)",
            },
          },
        },
      },
    });

  return (
    <>
      <div className="section-box">
        <h3 className="section-heading">Personal Information</h3>
        <div className="form-wrapper">
          <div className="input-field-div-wrapper">
            <select
              className="dropdown-control-large-insidetextfield"
              id="MemberCodeId"
              {...register("MemberCodeId", {
                required: "Member Code is a required field",
              })}
              onChange={(e) => {
                updateSelectBox(e);
              }}
              value={
                typeof personalInfo != "undefined"
                  ? personalInfo.MemberCodeId
                  : ""
              }
            >
              <option value={""}> Select Member Code ( * )</option>
              {props.configurationList.MemberCode?.map((MemberCode: any) =>
                MemberCode.Status ? (
                  <option key={MemberCode.Id} value={MemberCode.Id}>
                    {MemberCode.MemberCode} {" - "} {MemberCode.Description}
                  </option>
                ) : null
              )}
              ;
            </select>
            <p className="form-error  form-error-position">
              {errors.MemberCodeId?.message}
            </p>
          </div>
          <div className="input-field-div-wrapper">
            {/* <Label>Member ID</Label> */}
            <input
              className="input-field-div-small"
              placeholder=""
              id="BarId"
              {...register("BarId", {
                required: "BarID is a required field",
              })}
              onChange={(e) => {
                updateInput(e);
              }}
              autoComplete="off"
              value={personalInfo?.BarId}
            />
            <p className="form-error form-error-position">
              {errors.BarId?.message}
            </p>
            <label className="form-label" htmlFor="BarId">
              Bar ID ( * )
            </label>
          </div>

          <div className="input-field-div-wrapper">
            {/* <div className="selectfield-label">Title</div> */}
            <select
              className="dropdown-control-large-insidetextfield"
              name="Title"
              // {...register("Title", {
              //   required: "Title is a required field",
              // })}
              onChange={(e) => {
                updateSelectBox(e);
              }}
              // onChange={updateSelectBox}
              value={personalInfo ? personalInfo.Title : ""}
            >
              <option value={""}>-- Select Suffix --</option>
              {/* <option value="">
                  {memberApiData?.Personal.Title !== null
                    ? memberApiData?.Personal.Title
                    : "-- Title --"}
                </option> */}
              <option value="Jr.">Jr.</option>
              <option value="Sr.">Sr.</option>
              <option value="Ph.D">Ph.D</option>
              <option value="II">II</option>
              <option value="III">III</option>
              <option value="IV">IV</option>
              <option value="V">V</option>
              <option value="III Ph.D">III Ph.D</option>
              <option value="DOU">DOU</option>
            </select>
            {/* <p className="form-error form-error-position">{errors.Title?.message}</p> */}
          </div>

          <div className="input-field-div-wrapper">
            <input
              className="input-field-div-small"
              placeholder=""
              id="FirstName"
              {...register("FirstName", {
                required: "First Name is a required field",
              })}
              onChange={(e) => {
                updateInput(e);
              }}
              autoComplete="off"
              value={personalInfo ? personalInfo.FirstName! : ""}
            />
            <label className="form-label" htmlFor="FirstName">
              First Name ( * )
            </label>
            <p className="form-error form-error-position">
              {errors.FirstName?.message}
            </p>
          </div>
          <div className="input-field-div-wrapper">
            <input
              className="input-field-div-small"
              placeholder=""
              id="LastName"
              {...register("LastName", {
                required: "Last Name is a required field",
              })}
              onChange={(e) => {
                updateInput(e);
              }}
              autoComplete="off"
              value={personalInfo ? personalInfo.LastName : ""}
            />
            <label className="form-label" htmlFor="LastName">
              Last Name ( * )
            </label>
            <p className="form-error form-error-position">
              {errors.LastName?.message}
            </p>
          </div>
          <div className="input-field-div-wrapper">
            {/* <div className="selectfield-label">Esquire</div> */}
            <select
              className="dropdown-control-large-insidetextfield"
              name="Esquire"
              // {...register("Esquire", {
              //   required: "Esquire is a required field",
              // })}
              onChange={(e) => {
                updateSelectBox(e);
              }}
              // onChange={updateSelectBox}
              value={personalInfo ? personalInfo.Esquire : ""}
            >
              <option value={""}> Select Title</option>
              <option value="Esq">Esq.</option>
              <option value="Hon">Hon.</option>
              <option value="None">None</option>
            </select>
          </div>
          <div className="input-field-div-wrapper">
            <select
              className="dropdown-control-large-insidetextfield"
              name="Gender"
              onChange={(e) => {
                updateSelectBox(e);
              }}
              // onChange={updateSelectBox}
              value={personalInfo.Gender ?? ""}
            >
              <option value={""}> Select Gender </option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Unspecified">Unspecified</option>
            </select>
            <p className="form-error form-error-position">
              {errors.Gender?.message}
            </p>
          </div>

          <div style={{ width: "28%" }}>
            <Controller
              control={control}
              name="DateOfBirth"
              // rules={{ required: "* required field" }}
              render={({
                field: { onChange, onBlur, value, name, ref },
                fieldState: { error },
              }) => (
                <ThemeProvider theme={muiDatePickerColorTheme}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      className="datepicker-local"
                      label="Date Of Birth"
                      value={dayjs(dateOfBirth)}
                      slotProps={{
                        textField: {
                          error: Boolean(error),
                          helperText: error
                            ? errors.DateOfBirth?.message?.toString()
                            : "",
                        },
                      }}
                      onChange={(date) => {
                        if (dayjs(date).isValid()) {
                          console.log("dateofbirth:", date);
                          // dispatch(
                          //   updateMember_DateOfBirth(
                          //     dayjs(date!).format("YYYY-MM-DD")
                          //   )
                          // );
                          dispatch(
                            updateMemberPersonalInfo({
                              key: "DateOfBirth",
                              value: dayjs(date!).format("YYYY-MM-DD"),
                            })
                          );
                        }
                        setValue("DateOfBirth", dayjs(date), {
                          shouldDirty: true,
                        });
                      }}
                    />
                  </LocalizationProvider>
                </ThemeProvider>
              )}
            />
          </div>

          <div style={{ width: "28%" }}>
            <Controller
              control={control}
              name="AdmitDate"
              rules={{ required: "* required field" }}
              render={({
                field: { onChange, onBlur, value, name, ref },
                fieldState: { error, isDirty },
              }) => (
                <ThemeProvider theme={muiDatePickerColorTheme}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      className="datepicker-local"
                      label="Admit Date ( * ) "
                      value={dayjs(admitDate)}
                      slotProps={{
                        textField: {
                          error: Boolean(error),
                          helperText: error
                            ? errors.AdmitDate?.message?.toString()
                            : "",
                        },
                      }}
                      onChange={(date) => {
                        if (dayjs(date).isValid()) {
                          // dispatch(
                          //   updateMember_AdmitDate(
                          //     dayjs(date, "YYYY-MM-DD").format("YYYY-MM-DD")
                          //   )
                          // );
                          dispatch(
                            updateMemberPersonalInfo({
                              key: "AdmitDate",
                              value: dayjs(date!).format("YYYY-MM-DD"),
                            })
                          );
                          setValue("AdmitDate", dayjs(date), {
                            shouldDirty: true,
                          });
                          clearErrors("AdmitDate");
                        }
                      }}
                    />
                  </LocalizationProvider>
                </ThemeProvider>
              )}
            />
          </div>
          <div style={{ width: "28%" }}>
            <div
              key="1"
              className="checkboxgroup"
              style={{ height: "4rem", width: "100%" }}
            >
              <input
                id="1"
                className="checkbox"
                type="radio"
                {...register("IsMediatorOrArbitrator")}
                checked={isMediator}
                onChange={(event) => updateInput(event, "isMediator")}
              />
              <span style={{ width: "15rem" }}>Mediator </span>
              <input
                id="1"
                className="checkbox"
                type="radio"
                {...register("IsMediatorOrArbitrator")}
                checked={isArbitrator}
                onChange={(event) => updateInput(event, "isArbitrator")}
              />
              <span style={{ width: "15rem" }}>Arbitrator</span>
            </div>
          </div>
          <div style={{ width: "28%" }}>
            {isMediator || isArbitrator ? (
              <div className="mt-3" style={{ width: "100%" }}>
                <Controller
                  control={control}
                  name="MediatorCertificationEndsOn"
                  rules={{ required: "* required field" }}
                  render={({
                    field: { onChange, onBlur, value, name, ref },
                    fieldState: { error },
                  }) => (
                    <ThemeProvider theme={muiDatePickerColorTheme}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          className="datepicker-local"
                          label="Certification Ends On"
                          value={dayjs(MediatorCertificationEndsOn)}
                          slotProps={{
                            textField: {
                              error: Boolean(error),
                              helperText: error
                                ? errors.MediatorCertificationEndsOn?.message?.toString()
                                : "",
                            },
                          }}
                          onChange={(date) => {
                            if (dayjs(date).isValid()) {
                              // dispatch(
                              //   updateMember_MediatorCertificationEndsOn(
                              //     dayjs(date, "YYYY-MM-DD").format("YYYY-MM-DD")
                              //   )
                              // );
                              dispatch(
                                updateMemberPersonalInfo({
                                  key: "MediatorCertificationEndsOn",
                                  value: dayjs(date!).format("YYYY-MM-DD"),
                                })
                              );
                              setValue(
                                "MediatorCertificationEndsOn",
                                dayjs(date),
                                {
                                  shouldDirty: true,
                                }
                              );
                              clearErrors("MediatorCertificationEndsOn");
                            }
                          }}
                        />
                      </LocalizationProvider>
                    </ThemeProvider>
                  )}
                />
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateMemberPersonal;
